import { values } from "@/mocks/home";

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-primary-600 text-xs tracking-[0.32em] font-semibold mb-4">
              WHO WE ARE
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              <span className="block whitespace-nowrap">당신의 권리를 지키는</span>
              <span className="block whitespace-nowrap text-primary-600">믿을 수 있는</span>
              <span className="block whitespace-nowrap">손해사정 파트너</span>
            </h2>
            <p className="mt-8 text-foreground-700 leading-relaxed">
              다다손해사정은 고객의 문제를 정확하게 파악하고 효과적인 법률서비스를 제공합니다.
              관련 전문가와의 협업을 통한 최상의 솔루션을 제공하며,
              고객의 신뢰를 바탕으로 함께 성장하는 것을 목표로 합니다.
            </p>
            <div className="mt-10 flex flex-col gap-3">
              {[
                "법률·의료·보험 등 다양한 분야 전문가 네트워크 구축",
                "정확한 자료 분석과 객관적인 평가로 정당한 보상 실현",
              ].map((t) => (
                <div key={t} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 mt-1">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span className="text-foreground-800 text-sm">{t}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-5 items-stretch">
            {values.map((v) => (
              <div
                key={v.en}
                className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 flex flex-col h-full"
              >
                <div className="relative h-56 w-full overflow-hidden">
                  <img
                    src={v.img}
                    alt={v.en}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 flex items-center gap-2">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500">
                      <i className={`${v.icon} text-background-50`}></i>
                    </span>
                    <span className="text-background-50 text-xs tracking-[0.28em]">
                      {v.en.toUpperCase()}
                    </span>
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="font-heading font-bold text-xl text-foreground-950">
                    {v.ko}
                  </div>
                  <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}